/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Link } from '@coursera/cds-core';

import type { NormalizedInProgressCourse } from 'bundles/degree-home/components/v2/types/courseStates';
import { getCourseLink } from 'bundles/degree-home/utils/Course';

type Props = {
  courseState: NormalizedInProgressCourse;
};

export const CurrentCourseItem = ({ courseState }: Props) => {
  return (
    <div
      css={css`
        margin-top: var(--cds-spacing-200);
      `}
    >
      <Link
        href={getCourseLink(courseState)}
        variant="quiet"
        typographyVariant="bodyPrimary"
        data-e2e={`current-course-item-link ${courseState.name}`}
      >
        {courseState.name}
      </Link>
    </div>
  );
};
export default CurrentCourseItem;
